import React from "react";
import { Navigate, Route } from "react-router-dom";
import { isLoggedIn } from "../utils/Auth";
import {
  createTheme,
  ThemeProvider,
} from "@mui/material/styles";
import { themeOptions } from "../theme";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const isLoggedIn2 = isLoggedIn();
  const theme = createTheme(themeOptions);

  return isLoggedIn2 ? (
    <ThemeProvider theme={theme}>
      <Component />
    </ThemeProvider>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoute;
